import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mainSurvey" }
const _hoisted_2 = { class: "q1" }
const _hoisted_3 = { class: "with-margin" }
const _hoisted_4 = { class: "with-margin" }
const _hoisted_5 = { class: "mainSurvey-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_radio_button = _resolveComponent("radio-button")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.isCallSurvey ? _ctx.$t('survey_04_01_call') : _ctx.$t('survey_04_01')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.isCallSurvey ? _ctx.$t('survey_04_02_call') : _ctx.$t('survey_04_02')), 1),
      _createVNode(_component_radio_button, {
        text: _ctx.data,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.change($event))),
        value: _ctx.faqHelpfulnessScale.toString()
      }, null, 8, ["text", "value"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Button, {
        class: "footer-button",
        size: 'large',
        text: _ctx.$t('previous'),
        type: 'outlined',
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goBack()))
      }, null, 8, ["text"]),
      _createVNode(_component_Button, {
        class: "footer-button",
        disabled: !_ctx.faqHelpfulnessScale,
        size: 'large',
        text: _ctx.$t('next'),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nextScreen()))
      }, null, 8, ["disabled", "text"])
    ])
  ]))
}